import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  proposalLoading,
  selectProposal,
  setCustomRoute,
} from "../../features/counter/proposalSlice";
import BigPaperCover from "../BigPaperCover";
import ClosedProposalItems from "./ClosedProposalItems";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { apiBaseUrl, network } from "../../Common/config";

function ClosedProposal() {
  const { proposals, loading, networkId } =
    useSelector(selectProposal);
  const [pendingData, setPendingData] = useState([]);
  const dispatch = useDispatch();

  const isClosedProposal = (item) => {
    const stateName = item?.stateName;
    const state = `${item?.state ?? ""}`;
    return (
      stateName === "Canceled" ||
      stateName === "Defeated" ||
      stateName === "Expired" ||
      stateName === "Executed" ||
      state === "2" ||
      state === "3" ||
      state === "6" ||
      state === "7"
    );
  };

  const fallbackClosedProposals = () => {
    const reduxClosed = Array.isArray(proposals)
      ? proposals.filter((item) => isClosedProposal(item))
      : [];
    if (reduxClosed.length) {
      return reduxClosed;
    }

    const stored = localStorage.getItem("proposals");
    if (!stored) {
      return [];
    }
    try {
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.filter((item) => isClosedProposal(item)) : [];
    } catch (e) {
      return [];
    }
  };

  const fetchCloseProposal = async () => {
    try {
      const res = await fetch(`${apiBaseUrl}proposals/closed`);
      if (!res.ok) {
        throw new Error(`Failed to fetch closed proposals: ${res.status}`);
      }
      const data = await res.json();
      if (Array.isArray(data?.data) && data.data.length) {
        setPendingData(data.data);
        return;
      }
      setPendingData(fallbackClosedProposals());
    } catch (e) {
      setPendingData(fallbackClosedProposals());
    } finally {
      dispatch(proposalLoading(false));
    }
  };


  useEffect(() => {
    dispatch(proposalLoading(true));
    dispatch(setCustomRoute("closedProposal"));
    fetchCloseProposal();

    return () => {
      setPendingData([]);
    };
  }, [proposals]);


  return (
    <BigPaperCover to="proposalOptions">
      <p className="4xl:text-6xl 3xl:text-5xl 3xl:mb-10 3xl:mt-8 2xl:text-4xl xl:text-3xl 2xl:mb-8 2xl:mt-6 text-2xl font-semibold font-Nixie mb-4">
        Closed Proposals
      </p>
      <div className="overflow-y-scroll font-Nixie font-medium sm:text-lg text-sm min-w-full 2xl:max-h-55 max-h-50">
        {!loading && pendingData ? (
          pendingData?.length ? (
            pendingData?.map((details, i) => (
              <ClosedProposalItems details={details} key={i} />
            ))
          ) : (
            <div className="flex sm:w-full justify-evenly items-center">
              {networkId == network ? (
                <p className="text-xl sm:text-2xl m-auto font-semibold 3xl:text-4xl ">
                  No completed acts found
                </p>
              ) : (
                <p className="text-2xl m-auto font-semibold 3xl:text-4xl">
                  Wrong Network
                </p>
              )}
            </div>
          )
        ) : (
          <div className="flex sm:w-5/12 m-auto w-full justify-evenly items-center">
            <p className="3xl:text-6xl  3xl:mt-10 sm:text-2xl text-xl">
              Loading ...
            </p>
            <AiOutlineLoading3Quarters className="3xl:mt-10 3xl:w-16 3xl:h-16 animate-spin sm:w-8 sm:h-8 h-6 w-6" />
          </div>
        )}
      </div>
      <Link
        to="/proposalOptions"
        className="text-lg underline font-Nixie mt-3 absolute -bottom-3 sm:invisible visible"
      >
        Back
      </Link>
    </BigPaperCover>
  );
}

export default ClosedProposal;
